import freezer from '@manage/api/api.freezer'
export default [
  {
    type: 'input',
    placeholder: '设备SN码',
    filed: 'assetNumber',
    default: ''
  },
  {
    type: 'select',
    placeholder: '预警类型',
    filed: 'excSituation',
    default: '',
    query: freezer.alarm_select + '?devType=01&excType=01'
  },
  {
    type: 'select',
    placeholder: '报警状态',
    filed: 'state',
    default: '',
    options: [
      {
        code: '0',
        name: '已消除'
      },
      {
        code: '1',
        name: '报警中'
      }
    ]
  },
  {
    type: 'datepicker',
    filed: 'daterange',
    params: {
      start: 'startTime',
      end: 'endTime'
    },
    default: ''
  }
]
